export class ProblemCase {
    constructor(
        public problemCaseTemplateUniquename: string,
        public searchEntityIds: number[],
        public senderEmailId: number,
        public recipientIds: number[],
        public subject: string,
        public content: string,
    ) {}
}
